var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getAutomation } from '@citrus/runtime';
import { Styled } from './Sortable.styled';
/** DISPLAY NAME: &lt;SortableStatic.Column&gt; */
var StaticColumn = function (_a) {
    var automationId = _a.automationId, _b = _a.align, align = _b === void 0 ? 'left' : _b, children = _a.children, other = __rest(_a, ["automationId", "align", "children"]);
    var otherProps = __assign({}, other);
    otherProps.className = "".concat(other.className || '', " pcty-type-").concat(align, "align pcty-sortable-static-list-column").trim();
    return (React.createElement(Styled.StaticColumn, __assign({}, getAutomation(automationId, 'static-column'), otherProps), children));
};
export default StaticColumn;
